export enum INgxChatUiMessageActionSelectItemActionType{
  flow,
  redirect
}
